import React from 'react';
import { CellProps } from 'react-table';
import { CartTableItem } from '../../CartTable.model';
import PriceCellView from './PriceCell.view';

type Props = CellProps<CartTableItem> & {
  unspecified?: boolean
  cell?
};

const PriceCell: React.FC<Props> = (props: Props) => {
  const workRow = props.cell.row.original.reference.includes('Work');

  return <PriceCellView workRow={workRow} unspecified={props.unspecified} value={props.value}></PriceCellView>;
};

PriceCell.displayName = 'PriceCell';

export default PriceCell;
